import Hide from './Hide'
export { Hide }
export default Hide
